import { motion } from "framer-motion";

export const ShieldLogo = ({ size = "md" }) => {
  const s = { sm: 40, md: 56, lg: 80 }[size] || 56;
  return (
    <motion.div data-testid="shield-logo" className="inline-flex animate-shield-pulse">
      <svg width={s} height={s} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M40 6L12 20V42C12 58.5 24.5 73.5 40 78C55.5 73.5 68 58.5 68 42V20L40 6Z"
          stroke="#D4AF37" strokeWidth="2.5" fill="rgba(212, 175, 55, 0.06)" />
        <path d="M40 14L18 25V42C18 55.2 28.2 67 40 71C51.8 67 62 55.2 62 42V25L40 14Z"
          stroke="#D4AF37" strokeWidth="1" opacity="0.3" fill="none" />
        {/* Eye inside shield */}
        <path d="M24 42C24 42 31 32 40 32C49 32 56 42 56 42C56 42 49 52 40 52C31 52 24 42 24 42Z"
          stroke="#00FF41" strokeWidth="1.5" fill="none" opacity="0.8" />
        <circle cx="40" cy="42" r="6" stroke="#00FF41" strokeWidth="1.5" fill="rgba(0, 255, 65, 0.1)" />
        <motion.circle cx="40" cy="42" r="3" fill="#00FF41"
          animate={{ scale: [1, 1.3, 1], opacity: [0.8, 1, 0.8] }}
          transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }} />
        <circle cx="37" cy="40" r="1.2" fill="white" opacity="0.5" />
      </svg>
    </motion.div>
  );
};
